import utils from 'utils'
import fuzzySearch from './fuzzysearch'

export default class lockRecordListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, sweetalert, initSortService, operationService, $location) {

        function initDict() {
            const dictTypeArr = ['tax_belong_region']
            return httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res1) => {
                return res1.data.value
            })
        }

        $scope.treeConfig = {
            width: '150%',
            isCheckall: true,
            concatParentChild: true,
            concatParentChildChecked: true,
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }
        $scope.datePickerConfig = {
            autoclose: true, // 当选择一个日期之后是否立即关闭此日期时间选择器。
            minView: 'month', // 日期时间选择器所能够提供的最精确的时间选择视图。 选择日期后，不会再跳转去选择时分秒
            language: 'zh-CN', // 语言
            format: 'yyyy-mm-dd', // 格式
            forceParse: 0, // 是否强制解析输入框中的值
            pickTime: false,
            pickerPosition: 'bottom-right', // 出现的位置 默认值: 'bottom-right' (还支持 : 'bottom-left')
        }
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                orgIdList: [$scope.userInfo.org.orgId], //管理范围 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],

            },
        }

        $scope.selectedRows = []

        $scope.customizedConfig = {
            version: 1.04,
            queryConfig: [
                {
                    label: '所属机构',
                    key: 'orgIdList',
                    type: 'orgIdList',
                    dict: '',
                    selected: true,
                },
                {
                    label: '税务账号',
                    key: 'taxAccountName',
                    type: 'input',
                    dict: '',
                    selected: true,
                },
                {
                    label: '所属地区',
                    key: 'taxBelongRegion',
                    type: 'select',
                    dict: 'tax_belong_region',
                    selected: true,
                }, {
                    label: '锁定类型',
                    key: 'operationType',
                    type: 'select',
                    dict: 'lock_type',
                    selected: true,
                }, {
                    label: '操作时间',
                    key: 'operationDate',
                    type: 'date',
                    selected: true,
                },
            ],
            table: [
                {
                    label: '税务账号',
                    key: 'taxAccountName',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '所属机构',
                    key: 'orgName',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '所属地区',
                    key: 'taxBelongRegion',
                    type: 'dict',
                    dict: 'tax_belong_region',
                    selected: true,
                }, {
                    label: '锁定类型',
                    key: 'operationType',
                    type: 'dict',
                    dict: 'lock_type',
                    selected: true,
                },
                {
                    label: '错误信息',
                    key: 'errMessage',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '操作人',
                    key: 'operator',
                    type: '',
                    dict: '',
                    selected: true,
                },
                {
                    label: '操作时间',
                    key: 'operationTime',
                    type: '',
                    dict: '',
                    selected: true,
                }, {
                    label: '自动解锁时间',
                    key: 'autoUnlockTime',
                    type: '',
                    dict: '',
                    selected: true,
                },
            ],
        }
        async function init() {
            httpRequest.get_getUserOrgList().then((res) => {
                $scope.orgList = res.data.value
                $scope.selectedOrgs = $scope.orgList.filter((ele) => {
                    if (ele.orgId === $scope.userInfo.org.orgId) {
                        ele.checked = true
                    }
                })
            })
            $scope.dictData = await initDict()
            $scope.dictData.lock_type = [
                {
                    enumName: '短信发送超次数锁定',
                    enumCode: '1',
                },
                {
                    enumName: '短信发送超次数解锁',
                    enumCode: '2',
                }, {
                    enumName: '无公司关联关系锁定',
                    enumCode: '3',
                }, {
                    enumName: '无公司关联关系解锁',
                    enumCode: '4',
                }, {
                    enumName: '登录失败锁定（自动解锁）',
                    enumCode: '5',
                }, {
                    enumName: '登录失败解锁',
                    enumCode: '6',
                }, {
                    enumName: '切换超次数锁定（自动解锁）',
                    enumCode: '7',
                }, {
                    enumName: '切换超次数解锁',
                    enumCode: '8',
                },
            ]
            queryList()
        }
        init()
        $scope.reset = function () {
            $scope.queryParam.param = {
                orgIdList: [$scope.userInfo.org.orgId], //管理范围 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
            }
        }

        //查询功能，和表头排序功能
        function queryList() {

            $scope.queryParam.param.orgIdList = $scope.queryParam.param.selectedOrgs.map((ele) => {
                return ele.orgId
            })
            httpRequest
                .post_drawerLockLogfindListByPage($scope.queryParam)
                .then((res) => {
                    let result = res.data.value
                    $scope.dataList = result.list
                    $scope.totalItems = result.total
                    $scope.queryParam.pageNum = result.pageNum
                    $scope.selectedRows = []
                })

        }



        $scope.search = function () {
            queryList()
        }
        $scope.pageChanged = function () {
            queryList()
        }
        $scope.tableDropdownConfig = [
            {
                label: '解锁',
                handler(item) {
                    let params = {
                        "operationType": '2',
                        "orgId": item.orgId,
                        "taxAccountName": item.taxAccountName,
                        "taxBelongRegion": item.taxBelongRegion,
                    }
                    httpRequest.post_unlock(params).then(() => {
                        logger.logSuccess('解锁成功')
                        queryList()
                    })
                },
                showWhile(item, hasPermit) {
                    return item.operationType == 1
                },
            },
        ]
        $scope.add = function () {
            $state.go('system.basedata.taxAccount.add')
        }
        $scope.back = function () {
            $state.go('system.basedata.taxAccount.list')
        }
    }
}
lockRecordListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'sweetalert', 'initSortService', 'operationService', '$location']



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxAccount/lockRecordListCtrl.js